
import { useProfileTab } from "./profile/hooks/useProfileTab";
import { ProfileTabContent } from "./profile/components/ProfileTabContent";

export const ProfileTab = () => {
  const {
    profile,
    showPasswordChange,
    handleLogout,
    handleProfileUpdate,
    navigate
  } = useProfileTab();

  return (
    <ProfileTabContent
      profile={profile}
      showPasswordChange={showPasswordChange}
      onProfileUpdate={handleProfileUpdate}
      onLogout={handleLogout}
      onNavigate={navigate}
    />
  );
};
